import { MainPageLayout } from 'src/common/layouts/MainPageLayout';
export default MainPageLayout;
